/**
 * ES6 replacement for $(document).ready(() => {})
 *
 * @param {() => any} callBack
 */
export const windowReady = (callBack) => {
    if (document.readyState === 'complete') {
        callBack();
    } else {
        window.addEventListener('load', callBack);
    }
}
